export default {
  title: 'Journaux système',
  source: 'Connecté à l’instance : {{instanceId}} · Fichier : {{fileName}}',
  instances: 'Instances',
  localInstance: '{{instanceId}} (connectée)',
  instanceLost: 'Cette instance a cessé d’envoyer son journal (arrêtée ou injoignable)',
  status: {
    connecting: 'Connexion...',
    connected: 'En direct',
    disconnected: 'Déconnecté',
  },
  searchPlaceholder: 'Filtrer les lignes...',
  levels: {
    error: 'Erreur',
    warn: 'Avertissement',
    info: 'Info',
    debug: 'Débogage',
  },
  httpRequests: 'Requêtes HTTP',
  httpRequestsTitle: 'Afficher ou masquer les lignes journalisant les requêtes HTTP traitées par le serveur',
  maxLines: 'Lignes max',
  pause: 'Pause',
  resume: 'Reprendre ({{count}} nouvelles)',
  export: 'Exporter',
  exportTitle: 'Télécharger toutes les lignes chargées (sans appliquer les filtres) dans un fichier texte',
  clear: 'Effacer',
  reconnect: 'Reconnecter',
  jumpToLatest: 'Aller aux plus récentes',
  fileNotFound: 'Instance {{instanceId}} : fichier journal {{fileName}} introuvable, en attente de sa création',
  linesCount: '{{visible}} lignes affichées sur {{total}}',
  markers: {
    rotated: 'rotation du fichier journal',
    skipped: 'trop de lignes écrites : certaines lignes ont été ignorées',
    truncated: 'lignes plus anciennes non chargées',
  },
}
